import { render, staticRenderFns } from "./IconSectionCta.vue?vue&type=template&id=4ca7e331&"
import script from "./IconSectionCta.vue?vue&type=script&lang=js&"
export * from "./IconSectionCta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca7e331')) {
      api.createRecord('4ca7e331', component.options)
    } else {
      api.reload('4ca7e331', component.options)
    }
    module.hot.accept("./IconSectionCta.vue?vue&type=template&id=4ca7e331&", function () {
      api.rerender('4ca7e331', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSectionCta.vue"
export default component.exports